export var AuditLogAction;
(function (AuditLogAction) {
    AuditLogAction["AuditLogActionUnspecified"] = "AUDIT_LOG_ACTION_UNSPECIFIED";
    AuditLogAction["Trigger"] = "TRIGGER";
    AuditLogAction["Create"] = "CREATE";
    AuditLogAction["Update"] = "UPDATE";
    AuditLogAction["Delete"] = "DELETE";
    AuditLogAction["Read"] = "READ";
    AuditLogAction["Auth"] = "AUTH";
    AuditLogAction["Export"] = "EXPORT";
})(AuditLogAction || (AuditLogAction = {}));
